import { render, staticRenderFns } from "./NewMemberSpin.vue?vue&type=template&id=2110b4f2&scoped=true&"
import script from "./NewMemberSpin.vue?vue&type=script&lang=js&"
export * from "./NewMemberSpin.vue?vue&type=script&lang=js&"
import style0 from "./NewMemberSpin.vue?vue&type=style&index=0&id=2110b4f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2110b4f2",
  null
  
)

export default component.exports